<template>
    <div id="looporderlist_view">
        <div style="width: 100%; position: fixed; left: 0; top: 0; z-index: 9;">
            <van-nav-bar
                    title=""
                    left-text=""
                    right-text=""
                    left-arrow
                    @click-left="onClickLeft"
                    @click-right="onClickRight"
            >
                <template #left>
                    <van-icon name="arrow-left" color="#000000" />
                    <span>Volver</span>
                </template>
            </van-nav-bar>
        </div>
        <div class="privac_wrap" style="padding-top: 46px;">
            <van-pull-refresh
                    v-model="loading"
                    @refresh="orderListRefresh"
                    pulling-text="Se puede actualizar desplegando..."
                    loosing-text="Se puede actualizar liberando..."
                    loading-text="En carga..."
            >

                <template v-if="orderMessageList && orderMessageList.length > 0">
                <div style="padding: 0 0 50px 0;">
                    <div class="couponslist_cont" v-for="(item, index) in orderMessageList" :key="index">
                        <div class="actuales_middle">
                            <div class="redetail_coupons_form">
                                <div class="loophome_vcarddown_overdue_tags" @click.stop="onHandleDetail(item)">
                                    <template>
                                        <div class="loophome_vcarddown_ovtags_left">
                                            <template v-if="item.opv_vhe_tuh == 2">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                </div>
                                                <span>Revisando</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 3">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                </div>
                                                <span>Verificación fallada</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 4">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                </div>
                                                <span>Revisando</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 5">
                                                <div class="loophome_vcarddown_ovtags_licon" >
                                                    <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                </div>
                                                <span>Revisando</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 7">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                </div>
                                                <span>Pendiente por pagar</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 8">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_thr.webp" alt="" />
                                                </div>
                                                <span>Liquidado</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 9">
                                                <template v-if="item.ack_vvx_swc == 0">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                    </div>
                                                    <span>Pendiente por pagar</span>
                                                </template>
                                                <template v-else>
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_fiv.webp" alt="" />
                                                    </div>
                                                    <span>Atrasado</span>
                                                </template>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 10">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_fur.webp" alt="" />
                                                </div>
                                                <span>Verificación fallada</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 11">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                </div>
                                                <span>Pendiente por pagar</span>
                                            </template>
                                            <template v-else-if="item.opv_vhe_tuh == 12">
                                                <div class="loophome_vcarddown_ovtags_licon">
                                                    <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                </div>
                                                <span>Revisando</span>
                                            </template>
                                        </div>
                                        <div class="loophome_vcarddown_ovtags_right" v-if="item.opv_vhe_tuh > 6">
                                            <img src="@/assets/loopimg/loophome_orderlist_arrow.webp" />
                                        </div>
                                    </template>
                                </div>
                                <div class="detail_scale-1px"></div>
                                <div class="loophome_vcarddown">
                                    <div class="loophome_vcarddleft">
                                        <div class="loophome_vcarddtext" v-if="item.opv_vhe_tuh == 2 || item.opv_vhe_tuh == 4 || item.opv_vhe_tuh == 5 || item.opv_vhe_tuh == 12 || item.opv_vhe_tuh == 12">Monto de solicitud</div>
                                        <div class="loophome_vcarddtext" v-else-if="item.opv_vhe_tuh == 8">Monto a pagar</div>
                                        <div class="loophome_vcarddtext" v-else>Monto a pagar</div>
                                        <div class="loophome_vcarddval">$
                                            <span v-if="item.opv_vhe_tuh < 7">{{ item.xhs_ekl_oyo }}</span>
                                            <span v-else>
                                                            <template v-if="item.opv_vhe_tuh == 7 || item.opv_vhe_tuh == 9 || item.opv_vhe_tuh == 11">
                                                                {{ item.rpx_avd_omm }}
                                                            </template>
                                                            <template v-else-if="item.opv_vhe_tuh == 10">
                                                                {{ item.xhs_ekl_oyo }}
                                                            </template>
                                                            <template v-else>
                                                                {{ item.bvq_kbq_pva }}
                                                            </template>
                                                        </span>
                                        </div>
                                    </div>
                                    <div class="loophome_vcarddcenter">
                                        <div class="loophome_vcarddtext" v-if="item.opv_vhe_tuh == 2 || item.opv_vhe_tuh == 4 || item.opv_vhe_tuh == 5 || item.opv_vhe_tuh == 12 || item.opv_vhe_tuh == 12">Fecha de solicitar</div>
                                        <div class="loophome_vcarddtext" v-else-if="item.opv_vhe_tuh == 8">Fecha de pago</div>
                                        <div class="loophome_vcarddtext" v-else>Fecha de pago</div>
                                        <template v-if="item.opv_vhe_tuh == 7 || item.opv_vhe_tuh == 9 || item.opv_vhe_tuh == 11">
                                            <div class="loophome_vcarddval">{{ item.emo_xri_pmp }}</div>
                                        </template>
                                        <template v-else>
                                            <div class="loophome_vcarddval">{{ item.bhp_iwl_waq }}</div>
                                        </template>
                                    </div>
                                </div>

                                <div class="loophome_vcarddtextdute" v-if="item.opv_vhe_tuh == 9 && item.ack_vvx_swc > 0">Paga ahora mismo para evitar interés moratorio</div>

                            </div>
                        </div>
                    </div>
                </div>
                </template>
                <template v-else>
                    <div class="couponslist_cont">
                        <div class="historiales_nothing">
                            <div class="historiales_nothimg"></div>
                            <div class="historiales_nothtext"
                            >Todavía no tienes pedido, ve a solicitar tu factura</div
                            >
                        </div>
                    </div>
                </template>

                <!--<van-tabs v-model="activeName" sticky @click="ontabClick">
                    <van-tab title="Pedidos Actuales" name="actuales">
                        <template v-if="orderMessageList && orderMessageList.length > 0">
                            <div class="detail_scale-1px"></div>
                            <div style="padding: 0 0 50px 0;">
                                <div class="couponslist_cont" v-for="(item, index) in orderMessageList" :key="index">
                                    <div class="actuales_middle">
                                        <div class="redetail_coupons_form">
                                            <div class="loophome_vcarddown_overdue_tags" @click.stop="onHandleDetail(item)">
                                                <template>
                                                    <div class="loophome_vcarddown_ovtags_left">
                                                        <template v-if="item.opv_vhe_tuh == 2">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                            </div>
                                                            <span>Revisando</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 3">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                            </div>
                                                            <span>Verificación fallada</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 4">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                            </div>
                                                            <span>Revisando</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 5">
                                                            <div class="loophome_vcarddown_ovtags_licon" >
                                                                <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                            </div>
                                                            <span>Revisando</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 7">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                            </div>
                                                            <span>Pendiente por pagar</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 8">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_thr.webp" alt="" />
                                                            </div>
                                                            <span>Liquidado</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 9">
                                                            <template v-if="item.ack_vvx_swc == 0">
                                                                <div class="loophome_vcarddown_ovtags_licon">
                                                                    <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                                </div>
                                                                <span>Pendiente por pagar</span>
                                                            </template>
                                                            <template v-else>
                                                                <div class="loophome_vcarddown_ovtags_licon">
                                                                    <img src="@/assets/loopimg/looporder_status_fiv.webp" alt="" />
                                                                </div>
                                                                <span>Atrasado</span>
                                                            </template>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 10">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_fur.webp" alt="" />
                                                            </div>
                                                            <span>Verificación fallada</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 11">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                            </div>
                                                            <span>Pendiente por pagar</span>
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 12">
                                                            <div class="loophome_vcarddown_ovtags_licon">
                                                                <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                            </div>
                                                            <span>Revisando</span>
                                                        </template>
                                                    </div>
                                                    <div class="loophome_vcarddown_ovtags_right" v-if="item.opv_vhe_tuh > 6">
                                                        <img src="@/assets/loopimg/loophome_orderlist_arrow.webp" />
                                                    </div>
                                                </template>
                                            </div>
                                            <div class="detail_scale-1px"></div>
                                            <div class="loophome_vcarddown">
                                                <div class="loophome_vcarddleft">
                                                    <div class="loophome_vcarddtext" v-if="item.opv_vhe_tuh == 2 || item.opv_vhe_tuh == 4 || item.opv_vhe_tuh == 5 || item.opv_vhe_tuh == 12 || item.opv_vhe_tuh == 12">Monto de solicitud</div>
                                                    <div class="loophome_vcarddtext" v-else-if="item.opv_vhe_tuh == 8">Monto a pagar</div>
                                                    <div class="loophome_vcarddtext" v-else>Monto a pagar</div>
                                                    <div class="loophome_vcarddval">$
                                                        <span v-if="item.opv_vhe_tuh < 7">{{ item.xhs_ekl_oyo }}</span>
                                                        <span v-else>
                                                            <template v-if="item.opv_vhe_tuh == 7 || item.opv_vhe_tuh == 9 || item.opv_vhe_tuh == 11">
                                                                {{ item.rpx_avd_omm }}
                                                            </template>
                                                            <template v-else-if="item.opv_vhe_tuh == 10">
                                                                {{ item.xhs_ekl_oyo }}
                                                            </template>
                                                            <template v-else>
                                                                {{ item.bvq_kbq_pva }}
                                                            </template>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="loophome_vcarddcenter">
                                                    <div class="loophome_vcarddtext" v-if="item.opv_vhe_tuh == 2 || item.opv_vhe_tuh == 4 || item.opv_vhe_tuh == 5 || item.opv_vhe_tuh == 12 || item.opv_vhe_tuh == 12">Fecha de solicitar</div>
                                                    <div class="loophome_vcarddtext" v-else-if="item.opv_vhe_tuh == 8">Fecha de pago</div>
                                                    <div class="loophome_vcarddtext" v-else>Fecha de pago</div>
                                                    <template v-if="item.opv_vhe_tuh == 7 || item.opv_vhe_tuh == 9 || item.opv_vhe_tuh == 11">
                                                        <div class="loophome_vcarddval">{{ item.emo_xri_pmp }}</div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="loophome_vcarddval">{{ item.bhp_iwl_waq }}</div>
                                                    </template>
                                                </div>
                                            </div>

                                            <div class="loophome_vcarddtextdute" v-if="item.opv_vhe_tuh == 9 && item.ack_vvx_swc > 0">Paga ahora mismo para evitar interés moratorio</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="detail_scale-1px"></div>
                            <div class="couponslist_cont">
                                <div class="historiales_nothing">
                                    <div class="historiales_nothimg"></div>
                                    <div class="historiales_nothtext"
                                    >Todavía no tienes pedido, ve a solicitar tu factura</div
                                    >
                                </div>
                            </div>
                        </template>
                    </van-tab>-->
                    <!--<van-tab name="historiales" title="Pedidos Historiales" style="padding-bottom: 70px;">
                        <template v-if="historyDateList && historyDateList.length">
                            <div class="detail_scale-1px"></div>
                            <div style="padding: 0 0 50px 0">
                            <div class="couponslist_cont" v-for="(item, index) in historyDateList" :key="index">
                                <div class="actuales_middle">
                                    <div class="redetail_coupons_form">

                                        &lt;!&ndash;<div class="redetail_cont" style="padding-top: 16px">
                                            <div class="confirmloan_msgitems detail_scale-1px">
                                                <div class="confirmloan_msgileft" style="color: #69706e"
                                                >Número de Pedido:</div
                                                >
                                                <div class="confirmloan_msgiright" style="color: #69706e">
                                                    {{ item.id_orden_id }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="redetail_cont detail_scale-1px" style="padding-top: 0.388889rem">
                                            <div class="confirmloan_msgitems">
                                                <div class="confirmloan_msgileft">Estado del Pedido</div>
                                                <div class="confirmloan_msgiright">
                                                    <span v-if="item.st_ordersta_us == 2">Revisando</span>
                                                    <span v-else-if="item.st_ordersta_us == 3">Verificación fallada</span>
                                                    <span v-else-if="item.st_ordersta_us == 4">Revisando</span>
                                                    <span v-else-if="item.st_ordersta_us == 5">Esperando el préstamo</span>
                                                    <span v-else-if="item.st_ordersta_us == 7">Esperando el reembolso</span>
                                                    <span v-else-if="item.st_ordersta_us == 8">Liquidado</span>
                                                    <span v-else-if="item.st_ordersta_us == 9">Pago atrasado</span>
                                                    <span v-else-if="item.st_ordersta_us == 10">Falla</span>
                                                    <span v-else-if="item.st_ordersta_us == 11">Reembolso parcial</span>
                                                    <span v-else-if="item.st_ordersta_us == 12">En préstamo</span>
                                                </div>
                                            </div>
                                            <div class="confirmloan_msgitems">
                                                <div class="confirmloan_msgileft">Monto de Pago</div>
                                                <div class="confirmloan_msgiright">{{
                                                    item.un_pagado_pt
                                                    }}</div>
                                            </div>
                                            <div class="confirmloan_msgitems">
                                                <div class="confirmloan_msgileft">Fecha de Pago</div>
                                                <div class="confirmloan_msgiright"
                                                >{{ item.de_fecha_re }}</div
                                                >
                                            </div>
                                        </div>&ndash;&gt;

                                        <div class="loophome_vcarddown_overdue_tags" @click.stop="onHandleDetail(item)">
                                            <div class="loophome_vcarddown_ovtags_left">
                                                <template v-if="item.opv_vhe_tuh == 2">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                    </div>
                                                    <span>Revisando</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 3">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                    </div>
                                                    <span>Verificación fallada</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 4">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                    </div>
                                                    <span>Revisando</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 5">
                                                    <div class="loophome_vcarddown_ovtags_licon" >
                                                        <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                    </div>
                                                    <span>Revisando</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 7">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                    </div>
                                                    <span>Pendiente por pagar</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 8">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_thr.webp" alt="" />
                                                    </div>
                                                    <span>Liquidado</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 9">
                                                    <template v-if="item.ack_vvx_swc == 0">
                                                        <div class="loophome_vcarddown_ovtags_licon">
                                                            <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                        </div>
                                                        <span>Pendiente por pagar</span>
                                                    </template>
                                                    <template v-else>
                                                        <div class="loophome_vcarddown_ovtags_licon">
                                                            <img src="@/assets/loopimg/looporder_status_fiv.webp" alt="" />
                                                        </div>
                                                        <span>Atrasado</span>
                                                    </template>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 10">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_fur.webp" alt="" />
                                                    </div>
                                                    <span>Verificación fallada</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 11">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_two.webp" alt="" />
                                                    </div>
                                                    <span>Pendiente por pagar</span>
                                                </template>
                                                <template v-else-if="item.opv_vhe_tuh == 12">
                                                    <div class="loophome_vcarddown_ovtags_licon">
                                                        <img src="@/assets/loopimg/looporder_status_one.webp" alt="" />
                                                    </div>
                                                    <span>Revisando</span>
                                                </template>
                                            </div>
                                            <div class="loophome_vcarddown_ovtags_right">
                                                &lt;!&ndash;<img src="@/assets/loopimg/loophome_vcarddr_arrow.webp" />&ndash;&gt;
                                            </div>
                                        </div>
                                        <div class="detail_scale-1px"></div>
                                        <div class="loophome_vcarddown">
                                            <div class="loophome_vcarddleft">
                                                <div class="loophome_vcarddtext" v-if="item.opv_vhe_tuh == 2 || item.opv_vhe_tuh == 4 || item.opv_vhe_tuh == 5 || item.opv_vhe_tuh == 12">Monto de solicitud</div>
                                                <div class="loophome_vcarddtext" v-else-if="item.opv_vhe_tuh == 8">Monto a pagar</div>
                                                <div class="loophome_vcarddtext" v-else>Monto a pagar</div>
                                                <div class="loophome_vcarddval">$
                                                    <span v-if="item.opv_vhe_tuh < 7">{{ item.xhs_ekl_oyo }}</span>
                                                    <span v-else>
                                                        <template v-if="item.opv_vhe_tuh == 7 || item.opv_vhe_tuh == 9 || item.opv_vhe_tuh == 11">
                                                            {{ item.rpx_avd_omm }}
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 10">
                                                            {{ item.xhs_ekl_oyo }}
                                                        </template>
                                                        <template v-else-if="item.opv_vhe_tuh == 8">
                                                            {{ item.xhs_ekl_oyo }}
                                                        </template>
                                                        <template v-else>
                                                            {{ item.bvq_kbq_pva }}
                                                        </template>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="loophome_vcarddcenter">
                                                <div class="loophome_vcarddtext" v-if="item.opv_vhe_tuh == 2 || item.opv_vhe_tuh == 4 || item.opv_vhe_tuh == 5 || item.opv_vhe_tuh == 12">Fecha de solicitar</div>
                                                <div class="loophome_vcarddtext" v-else-if="item.opv_vhe_tuh == 8">Fecha de pago</div>
                                                <div class="loophome_vcarddtext" v-else>Fecha de pago</div>
                                                <template v-if="item.opv_vhe_tuh == 7 || item.opv_vhe_tuh == 9 || item.opv_vhe_tuh == 11">
                                                    <div class="loophome_vcarddval">{{ item.emo_xri_pmp }}</div>
                                                </template>
                                                <template v-else>
                                                    <div class="loophome_vcarddval">{{ item.bhp_iwl_waq }}</div>
                                                </template>
                                            </div>
                                        </div>

                                        <div class="loophome_vcarddtextdute" v-if="item.opv_vhe_tuh == 9 && item.ack_vvx_swc > 0">Paga ahora mismo para evitar interés moratorio</div>

                                    </div>
                                </div>
                            </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="detail_scale-1px"></div>
                            <div class="couponslist_cont">
                                <div class="historiales_nothing">
                                    <div class="historiales_nothimg"></div>
                                    <div class="historiales_nothtext"
                                    >Todavía no tienes pedido, ve a solicitar tu factura</div
                                    >
                                </div>
                            </div>
                        </template>
                    </van-tab>
                </van-tabs>-->
            </van-pull-refresh>
        </div>

        <div id="cycledetialview">
            <van-popup :style="{ width: '100vw'}" position="bottom" v-model="cycleDetailShow">
                <div style="width: 100vw; margin-bottom: 10px;">
                    <div class="detail_wrap" style="width: 94.44vw;height: auto;background: #ffffff;margin: 0 auto;" v-if="cycleDetailDate">
                        <div class="detail_headview">
                            <div class="detail_headvleft"></div>
                            <div class="detail_title">Detalles</div>
                            <div class="detail_headvright" @click.stop="onCycleDetailHidden">
                                <img src="@/assets/loopimg/looppopu_close.webp" alt="">
                            </div>
                        </div>
                        <div class="detail_items" style="padding-bottom: 24px;">
                            <div class="detail_ileft">Monto a pagar pendiente</div>
                            <div class="detail_iright" style="font-weight: bold;font-size: 16px;">$ {{ cycleDetailDate.rpx_avd_omm }}</div>
                        </div>
                        <div class="detail_items">
                            <div class="detail_ileft">Monto a pagar total</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.bvq_kbq_pva }}</div>
                        </div>
                        <div class="detail_items">
                            <div class="detail_ileft">Fecha de pago</div>
                            <div class="detail_iright">{{ cycleDetailDate.bhp_iwl_waq }}</div>
                        </div>
                        <div class="detail_items">
                            <div class="detail_ileft">Principal</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.xhs_ekl_oyo }}</div>
                        </div>
                        <div class="detail_items">
                            <div class="detail_ileft">Interés</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.vsi_efg_ode }}</div>
                        </div>
                        <div class="detail_items">
                            <div class="detail_ileft">Comisión</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.lrt_tbw_aie }}</div>
                        </div>
                        <div class="detail_items">
                            <div class="detail_ileft">IVA</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.hkf_frh_klx }}</div>
                        </div>
                        <div class="detail_items">
                            <div class="detail_ileft">Interés moratorio</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.fff_mat_ywl }}</div>
                        </div>
                        <!--<div class="detail_items">
                            <div class="detail_ileft">Monto descontado</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.reduceAmount }}</div>
                        </div>-->
                        <div class="detail_items">
                            <div class="detail_ileft">Monto pagado</div>
                            <div class="detail_iright">$ {{ cycleDetailDate.pxl_rua_liz }}</div>
                        </div>
                    </div>
                </div>
            </van-popup>
        </div>

    </div>
</template>

<script>

    import { getTimezoneName, getUserIp } from '@/utils/commonParams';
    import { loadingShow, loadingHide } from '@/utils/loading'
    import { getAccessToken } from '@/utils/auth';
    import { parseTime, getNextDate, getQueryString } from "@/utils/index"

    import { orderListAll } from '@/api/loan'

    import { Toast } from 'vant';

    export default{
        data() {
            return {
                activeName: 'actuales',
                isaccordion: true,
                hasborder: false,
                activeNames: '',
                orderMessageList: [],
                historyDateList: [],
                cycleDetailShow: false,
                cycleDetailDate: null,
                loading: false,
            }
        },
        mounted() {
            this.allorderList(1);
        },
        methods: {
            onClickLeft() {
                this.$router.back();
            },
            onClickRight() {

            },
            ontabClick(e) {
                console.log(e);
                let usename = e;

                if (usename == 'actuales') {
                    this.allorderList(1);
                } else if (usename == 'historiales') {
                    this.allorderList(2);
                }
            },
            orderListRefresh() {
                this.loading = true;
                if (this.activeName == 'actuales') {
                    this.allorderList(1);
                } else if (this.activeName == 'historiales') {
                    this.allorderList(2);
                }
            },
            onHandleDetail(data) {
                console.log(data)
                if(data.opv_vhe_tuh > 6){
                    this.cycleDetailShow = true;
                    this.cycleDetailDate = data;
                }
            },
            onCycleDetailHidden() {
                this.cycleDetailShow = false;
            },
            async allorderList(type) {
                let _this = this;
                const login_token = getAccessToken();
                console.log(login_token)
                if(login_token){ //已经登录
                    console.log('已登录11111')
                    let time_zone = getTimezoneName();
                    console.log(time_zone);
                    loadingShow();
                    let ip = await getUserIp()
                    console.log(ip)

                    let postData = {
                        zzm_yya_hqb: getAccessToken(),
                        aaa_off_csl: '111',
                        yjk_wcu_vgd: 0,
                        or_da_typ: type,
                    };

                    let headerParams = {
                        'ad-justad-id': localStorage.getItem("adjust_id"),
                        'ad-justad-j': '',
                        'ad-justad-idfv': '',
                    };
                    this.orderMessageList = [];
                    this.historyDateList = [];
                    loadingShow();
                    orderListAll(postData, {
                        'bwd-irh-lnf': time_zone,
                        'xfo-plp-van': ip,
                        ...headerParams
                    }).then(res => {
                        console.log(res)
                        loadingHide()
                        this.loading = false;
                        this.isInfoLoading = false;
                        if(res.ci == 200){
                            let useData = res.da;
                            console.log(JSON.parse(useData))
                            if(useData){
                                let useDataJSON = JSON.parse(useData);

                                //de_orden_de.ac_tiempo_de = parseTime(de_orden_de.ac_tiempo_de, '{y}/{m}/{d}');

                                let { rav_nwv_evx } = useDataJSON;

                                if(rav_nwv_evx && rav_nwv_evx.length){
                                    if(type == 1){
                                        this.orderMessageList = rav_nwv_evx;
                                    } else {
                                        this.historyDateList = rav_nwv_evx;
                                    }
                                }

                            }
                        } else {
                            Toast(res.ms);
                        }
                    }, error => {
                        loadingHide()
                        this.loading = false;
                    });
                } else { //未登录
                    console.log('未登录1111')
                    this.$router.replace({
                        path: '/loanpage/loginhome'
                    })
                }
            },
            /*getOrderList: async (type, year, month) => {

                try {
                    loadingShow();
                    let postData = {};
                    if (type == '1' || type == '2') {
                        postData = {
                            es_orden_ti: type,
                        };
                    } else {
                        postData = {
                            es_orden_ti: type,
                            es_ano_pm: year,
                            es_ems_pm: month,
                        };
                    }

                    const { data } = await orderListAll(postData);
                    console.log(data);

                    if (data) {
                        if (type == '1') {
                            //当前订单信息
                            if (data.de_orden_de) {


                                let de_orden_de = data.de_orden_de;
                                de_orden_de.ap_tiempo_de = parseTime(de_orden_de.ap_tiempo_de, '{y}/{m}/{d}');
                                de_orden_de.de_tiempo_re = parseTime(de_orden_de.de_tiempo_re, '{y}/{m}/{d}');
                                de_orden_de.pr_tiempo_de = parseTime(de_orden_de.pr_tiempo_de, '{y}/{m}/{d}');
                                de_orden_de.ac_tiempo_de = parseTime(de_orden_de.ac_tiempo_de, '{y}/{m}/{d}');
                                de_orden_de.co_tiempo_de = parseTime(de_orden_de.co_tiempo_de, '{y}/{m}/{d}');

                                //state.orderMessage = de_orden_de;
                            }
                            //es_prestamo_de 首复贷 0首贷 1复贷
                            //or_estatus_pm 订单状态
                        } else if (type == '2') {
                            //历史订单
                            if (data.em_orden_li) {
                                console.log(data.em_orden_li);
                                this.historyDateList = data.em_orden_li;
                            }
                        } else if (type == '3') {
                            if (data.de_orden_li) {
                                let usede_orden_li = data.de_orden_li;
                                for (let i = 0; i < usede_orden_li.length; i++) {
                                    usede_orden_li[i].ap_tiempo_de = parseTime(
                                        usede_orden_li[i].ap_tiempo_de,
                                        '{y}/{m}/{d}'
                                    );
                                    usede_orden_li[i].de_tiempo_re = parseTime(
                                        usede_orden_li[i].de_tiempo_re,
                                        '{y}/{m}/{d}'
                                    );
                                    usede_orden_li[i].pr_tiempo_de = parseTime(
                                        usede_orden_li[i].pr_tiempo_de,
                                        '{y}/{m}/{d}'
                                    );
                                    usede_orden_li[i].ac_tiempo_de = parseTime(
                                        usede_orden_li[i].ac_tiempo_de,
                                        '{y}/{m}/{d}'
                                    );
                                    usede_orden_li[i].co_tiempo_de = parseTime(
                                        usede_orden_li[i].co_tiempo_de,
                                        '{y}/{m}/{d}'
                                    );
                                    usede_orden_li[i].id_orden_id_str = String(usede_orden_li[i].id_orden_id);
                                }

                                this.historyLoanList = usede_orden_li;
                            }
                        }
                    }
                } catch (error) {
                } finally {
                    loadingHide();
                    this.loading = false;
                }
            },*/

        }
    }
</script>

<style less scoped>
    privac_wrap{
        width: 100%;
        height: auto;
        position: relative;
    }
    .privac_wrap img{
        display: block;
        width: 100%;
    }
    .detail_scale-1px {
        position: relative;
        border: none;
    }
    .detail_scale-1px:after {
        content: '';
        position: absolute;
        bottom: 0;
        background: #e7e7e7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .confirmloan_msgitems {
        width: 100%;
        height: 18px;
        display: flex;
        justify-content: space-between;
    }
    .confirmloan_msgileft {
        width: auto;
        height: 7px;
        font-size: 7px;
        font-weight: 400;
        color: #69706e;
        line-height: 7px;
    }
    .confirmloan_msgiright {
        width: auto;
        height: 7px;
        font-size: 7px;
        font-weight: 500;
        color: #1a1a1a;
        line-height: 7px;
    }
    .confirmloan_msgiright span {
        padding-left: 3px;
    }
    .confirmloan_msgileft_active {
        padding-bottom: 4px;
    }
    .confirmloan_msgileft_active .confirmloan_msgileft {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
    }

    .historiales_nothing {
        width: 100%;
        height: 89px;
        box-sizing: border-box;
        padding-top: 35px;
        background: none;
    }
    .historiales_nothimg {
        /*width: 180px;*/
        /*height: 180px;*/
        /*margin: 0 auto;*/
        /*background: #d8d8d8;*/
    }
    .historiales_nothtext {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 9px 22px 0 22px;
        font-size: 12px;
        font-weight: 400;
        color: #a8aaa9;
        line-height: 14px;
        text-align: center;
    }
    .couponslist_cont {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 16px 14px 0 14px;
        background: rgba(255, 255, 255, 0);
    }
    .actuales_middle {
        width: 100%;
        height: auto;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
    }
    .redetail_coupons_form {
        width: 100%;
        height: auto;
        overflow-x: hidden;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 16px 0 16px;
    }

    .redetail_coupons_form .confirmloan_msgileft {
        font-size: 12px;
    }
    .redetail_coupons_form .confirmloan_msgiright {
        font-size: 12px;
    }
    .redetail_coupons_form .confirmloan_msgitems {
        height: 27px;
    }
    .detail_scale-1px {
        position: relative;
        border: none;
    }
    .detail_scale-1px:after {
        content: '';
        position: absolute;
        bottom: 0;
        background: #e7e7e7;
        width: 100%;
        height: 1px;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
    .confirmloan_msgitems {
        width: 100%;
        height: 36px;
        display: flex;
        justify-content: space-between;
    }
    .confirmloan_msgileft {
        width: auto;
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #69706e;
        line-height: 14px;
    }
    .confirmloan_msgiright {
        width: auto;
        height: 14px;
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
        line-height: 14px;
    }
    .confirmloan_msgiright span {
        padding-left: 5px;
    }
    .confirmloan_msgileft_active {
        padding-bottom: 8px;
    }
    .confirmloan_msgileft_active .confirmloan_msgileft {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
    }

    .historiales_nothing {
        width: 100%;
        height: 178px;
        box-sizing: border-box;
        padding-top: 70px;
        background: none;
    }
    .historiales_nothimg {
        /*width: 180px;*/
        /*height: 180px;*/
        /*margin: 0 auto;*/
        /*background: #d8d8d8;*/
    }
    .historiales_nothtext {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 18px 43px 0 43px;
        font-size: 16px;
        font-weight: 400;
        color: #a8aaa9;
        line-height: 22px;
        text-align: center;
    }

    .loophome_vcarddown_overdue_tags{
        width: 100%;
        height: 44px;
        border-radius: 8px 8px 0px 0px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .loophome_vcarddown_ovtags_left{
        width: auto;
        height: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .loophome_vcarddown_ovtags_left span{
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        text-align: left;
        font-style: normal;
    }
    .loophome_vcarddown_ovtags_cview{
        width: auto;
        margin-right: 130px;
    }
    .loophome_vcarddown_ovtags_center{
        width: auto;
        height: 14px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #ede4da;
        border: 1px solid #daaf80;
        border-radius: 7px 7px 7px 0px;
    }
    .loophome_vcarddown_ovtags_center span{
        font-weight: bold;
        font-size: 12px;
        color: #8F4700;
        line-height: 14px;
        text-align: left;
        font-style: normal;
        pxtransform:scale(0.83);
        -webkit-transform:scale(0.83);
    }
    .loophome_vcarddown_ovtags_right{
        width: 10px;
        height: 10px;
    }
    .loophome_vcarddown_ovtags_right img{
        display: block;
        width: 10px;
        height: 10px;
    }
    .loophome_vcarddown{
        width: 100%;
        height: 58px;
        border-radius: 0.222222rem;
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        padding: 8px 12px 0 0;
    }
    .loophome_vcarddleft{
        width: 167px;
        height: auto;
    }
    .loophome_vcarddtext{
        width: 100%;
        height: 0.472222rem;
        font-weight: 400;
        font-size: 0.305556rem;
        color: #69706E;
        line-height: 0.361111rem;
    }
    .loophome_vcarddval{
        width: 100%;
        height: auto;
        font-weight: 400;
        font-size: 0.361111rem;
        color: #393F3D;
    }
    .loophome_vcarddval span{
        padding-left: 0.111111rem;
    }
    #looporderlist_view{
        background: #F7F8F8;
    }
    #looporderlist_view .detail_wrap{
        width: 87.78vw;
        height: auto;
        box-sizing: border-box;
        padding: 0.555556rem 0.444444rem 0.444444rem 0.444444rem;
        border-radius: 15px;
    }
    #looporderlist_view .detail_title{
        width: 100%;
        height: 1.333333rem;
        font-weight: bold;
        font-size: 0.444444rem;
        color: #2C2C34;
        line-height: 0.444444rem;
        text-align: center;
    }
    #looporderlist_view .detail_items{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        padding-bottom: 16px;
    }
    #looporderlist_view .detail_ileft{
        width: 240px;
        height: 0.388889rem;
        font-weight: 400;
        font-size: 12px;
        color: #6B6B73;
        line-height: 0.388889rem;
        text-align: left;
    }
    #looporderlist_view .detail_iright{
        width: 4.166667rem;
        height: auto;
        font-weight: bold;
        font-size: 12px;
        color: #2C2C34;
        line-height: 0.388889rem;
        text-align: right;
    }
    #looporderlist_view .detail_footer{
        width: 100%;
        height: 1.111111rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .loophome_vcarddown_ovtags_licon{
        width: 20px;
        height: 20px;
        margin-right: 7px;
    }
    .loophome_vcarddown_ovtags_licon img{
        display: block;
        width: 20px;
        height: 20px;
    }
    .loophome_vcarddtextdute{
        width: 100%;
        height: 0.472222rem;
        font-weight: 400;
        font-size: 0.305556rem;
        color: #FF4C4C;
        line-height: 0.361111rem;
    }
    .detail_headview{
        width: 100%;
        height: 1.333333rem;
        display: flex;
        justify-content: space-between;
    }
    .detail_headvright{
        width: 24px;
        height: 24px;
        position: relative;
    }
    .detail_headvright img{
        display: block;
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0;
        top: -4px;
    }
</style>

<style>
    #looporderlist_view .van-tabs__line{
        background: #006747;
    }
    #looporderlist_view .van-tabs__content{
        width: 100%;
        height: calc(100vh - 99px);
        overflow-y: scroll;
    }
    #cycledetialview .van-popup{
        background: none;
    }
    #extenddetialview .van-popup{
        background: none;
    }
    #looporderlist_view .van-nav-bar__content{
        height: 50px;
    }
    #looporderlist_view .van-nav-bar__title{
        height: 50px;
    }
    #looporderlist_view .navtitle{
        height: 50px;
        line-height: 50px;
    }
    #looporderlist_view .van-ellipsis{
        overflow: auto;
    }
    #looporderlist_view .van-tabs__wrap{
        height: 49px;
    }
    #looporderlist_view .van-tabs__nav--line{
        height: 49px;
        padding-bottom: 0;
    }
    #looporderlist_view .van-tab{
        height: 49px;
        font-size: 14px;
    }
    #looporderlist_view .van-tabs__line {
        width: 40px;
        height: 3px;
        bottom: 0;
    }
    #looporderlist_view .van-tab__text {
        padding-top: 2px;
        overflow: auto;
    }
</style>

